// Calculate number of blocks to total based on IDs of select boxes
var blocks = 0;
var listOfBlocks = {};
$('select[id^=block]').each(function () {
    var currentBlock = $(this).attr('id');
    if (!listOfBlocks[currentBlock]) {
        listOfBlocks[currentBlock] = {};
        blocks++;
    }
});

// Get last part of URL to establish if final placements page
var segments = $(location).attr('href').split('/');
var last_segment = segments[segments.length - 1];

for (var i = 1; i <= blocks; i++) {
    if (last_segment == 'final') {
        var sumofchecked = 0;
        // Display total count of checked boxes at foot of column for final placements
        $('.block' + i + ':checked').each(function () {
            sumofchecked += $(this).data('count');
        });
        $('.countblock' + i).text(sumofchecked);
    } else {
        var sumofselect = 0;
        // Sum of all values selected in quantity dropdowns for each block and display in columns
        $('.block' + i).each(function () {
            if ($(this).find('option:selected').val() > 0) {
                $($(this).find('option:selected')).parent().addClass('highlight-select');
                sumofselect += parseInt($(this).find('option:selected').val());
            }
        });
        $('.countblock' + i).text(sumofselect);
    }
}

var addPlacementForm = $('#addPlacementForm');
var updatePlacementForm = $('#UpdatePlacementForm');

// Validate new GP placement form
$(addPlacementForm).validate({
    rules: {
        locationid: {
            required: true,
        },
    },
    messages: {
        locationid: 'Please select a GP placement',
    },
    submitHandler: function (form) {
        $('button[type="submit"]', addPlacementForm).prop('disabled', true).html('Saving placement ..... <i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + '"></i>');
        form.submit();
    },
});

window.update_gp = function (id) {
    var final = $('input[name=final]').val();
    var GPAjaxData = {};

    if (final) {
        GPAjaxData = {
            id: id,
            acyr: $('input[name=acyr_' + id + ']').val(),
            locationid: $('input[name=locationid_' + id + ']').val(),
            final: final,
            block1: $('input[name=block1_' + id + ']').prop('checked') == true ? 1 : 0,
            block2: $('input[name=block2_' + id + ']').prop('checked') == true ? 1 : 0,
            block3: $('input[name=block3_' + id + ']').prop('checked') == true ? 1 : 0,
            block4: $('input[name=block4_' + id + ']').prop('checked') == true ? 1 : 0,
            block5: $('input[name=block5_' + id + ']').prop('checked') == true ? 1 : 0,
            block6: $('input[name=block6_' + id + ']').prop('checked') == true ? 1 : 0,
            block7: $('input[name=block7_' + id + ']').prop('checked') == true ? 1 : 0,
            block8: $('input[name=block8_' + id + ']').prop('checked') == true ? 1 : 0,
            block9: $('input[name=block9_' + id + ']').prop('checked') == true ? 1 : 0,
            myvle_csrf_test_name: csrfToken,
        };
    } else {
        GPAjaxData = {
            id: id,
            acyr: $('input[name=acyr_' + id + ']').val(),
            locationid: $('input[name=locationid_' + id + ']').val(),
            final: final,
            block1: $('select[name=block1_' + id + ']').val(),
            block2: $('select[name=block2_' + id + ']').val(),
            block3: $('select[name=block3_' + id + ']').val(),
            block4: $('select[name=block4_' + id + ']').val(),
            block5: $('select[name=block5_' + id + ']').val(),
            block6: $('select[name=block6_' + id + ']').val(),
            block7: $('select[name=block7_' + id + ']').val(),
            block8: $('select[name=block8_' + id + ']').val(),
            block9: $('select[name=block9_' + id + ']').val(),
            requirecar: $('input[name=requirecar_' + id + ']').prop('checked') == true ? 1 : 0,
            notes: $('textarea[name=notes_' + id + ']').val(),
            myvle_csrf_test_name: csrfToken,
        };
    }
    $.ajax({
        type: 'POST',
        url: 'yr4/updategpavailability',
        data: GPAjaxData,
        beforeSend: function () {
            $($('#placement_' + id)).prop('disabled', true).html('<i class="' + FontAwesome.prefix('solid', 'arrows-rotate', true) + '"></i> Save');
        },
        success: function (GPAjaxData) {
            window.location.reload();
        },
        error: function (err, status) {
            console.log(err);
        },
    });
};
